export default {
    ATIVO: 1,
    ALTERAÇÃO_DE_AGENDA: 2,
    ATESTADO: 3,
    ATIVIDADE_ENCERRADA: 4,
    ATIVIDADE_DO_ESPEC_ENCERRADA: 5,
    BANCO_DE_HORAS: 5,
    CONGRESSO: 7,
    CURSO_ESPECIALIZAÇÃO: 8,
    EMERGÊNCIA: 9,
    FALTA: 10,
    FÉRIAS: 11,
    FERIADO_PONTO_FACULTATIVO: 12,
    FOLGA_ABONADA: 13,
    FOLGA_BANCO: 14,
    GALA: 15,
    LICENÇA_GESTANTE: 16,
    NOJO: 17,
    OUTROS: 18,
    PLANTÃO: 19,
    REPOSIÇÃO_DE_COTA: 20,
    RESERVADO: 21,
    TRIAGEM: 22,
}